import script from "./ExpenditureBusinessHandler.vue.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenditureBusinessHandler.vue.vue?vue&type=script&setup=true&lang=js"

import "./ExpenditureBusinessHandler.vue.vue?vue&type=style&index=0&id=50bf8d2f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50bf8d2f"]])

export default __exports__